import React from 'react';
import styled from 'styled-components';
import {
  primaryFont, secondaryFont, wMBold, wMedium,
} from 'Utils/utilsStyle';

const Header = styled.div`
  display: flex;
  align-items: center;
  border-bottom: 1px solid #DDDDDD;
  padding-bottom: 5px;
  margin-bottom: 7px;
  .header-item {
    min-width: 20%;
    width: 20%;
    font-size: 16px;
    font-weight: ${wMBold};
    font-family: ${primaryFont};
    color: #3F4B50;
    &:nth-child(1) {
    min-width: 40%;
    width: 40%;
    }
    &:nth-child(3), &:nth-child(4) {
     text-align: center;
    }
    &.heading {
      color: #424B50;
      font-size: 18px;
      font-weight: ${wMedium};
      font-family: ${secondaryFont};
    }
  }
`;

const EngagementPeopleTableHeader = function EngagementPeopleTableHeader() {
  return (
    <Header>
      <div className="header-item heading">Name</div>
      <div className="header-item">Accounts</div>
      <div className="header-item">Views</div>
      <div className="header-item">Profile Downloads</div>
    </Header>
  );
};

export default EngagementPeopleTableHeader;
